"use client";

import { useContext, useEffect, useRef, useState } from "react";
import { SurveyForm } from "@/components/common/resource-survey/components/survey-form/survey-form";
import { ResourceContext } from "@/contexts/resource-context";
import { logEvent } from "@/service/logs/log";
import { ActionPanel } from "@/components/common/action-panel";
import { Button } from "@/components/ui/button";
import { InfoWithCta } from "@/components/common/info-with-cta";
import { PartyPopperIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const ResourceSurvey = ({
  survey: { steps, canAnswer, id },
  resourceType,
  resourceId,
  title,
}: {
  survey: SurveyVM;
  resourceType: string;
  resourceId: number;
  title: string;
}) => {
  const ref = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const { logView } = useContext(ResourceContext);

  useEffect(() => {
    if (isModalOpen) {
      logEvent("survey_modal_open", logView, {
        resourceType,
        resourceId,
        survey_id: id,
      });
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [isModalOpen]);

  if (!canAnswer) {
    return <></>;
  }

  return (
    <>
      {!isModalOpen && !success && (
        <ActionPanel
          button={
            <Button variant={"blue"} onClick={() => setModalOpen(true)}>
              Wypełnij ankietę
            </Button>
          }
          title={"Co myślisz o tym materiale?"}
          message={
            "Będziemy wdzięczni, jeśli poświęcisz nam chwilę na dokładniejszy feedback!"
          }
        />
      )}

      <div ref={ref} className={cn("py-16", !isModalOpen && "hidden")}>
        <div
          className={`mb-2 text-center text-xl font-semibold text-black md:text-2xl`}
        >
          Ankieta VOD
        </div>
        <div className={`mb-8 text-center text-sm font-normal text-zinc-600`}>
          {title}
        </div>
        <div
          className={cn(
            "mx-auto w-full max-w-[400px] rounded-lg border-[0px] border-zinc-300 p-0 pt-4",
            "md:border-[1px] md:p-6 md:py-8",
          )}
        >
          {success ? (
            <InfoWithCta
              icon={<PartyPopperIcon />}
              title={"Dziękujemy za Twój czas i zaangażowanie!"}
              desc={"Twoja opinia pojawi się na stronie po jej weryfikacji."}
              cta={
                <Button variant={"blue"} onClick={() => setModalOpen(false)}>
                  Zamknij
                </Button>
              }
            />
          ) : (
            <SurveyForm
              steps={steps}
              id={id}
              setSuccess={setSuccess}
              resourceId={resourceId}
              resourceType={resourceType}
            />
          )}
        </div>
      </div>
    </>
  );
};
